import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, Button } from '@mui/material';
import { Modal, Typography } from 'shared';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

import {
    startTour,
    skipAllTours,
    setTutorialPreference,
    TOUR_TYPES,
    resetAllTours,
} from 'store/slices/tour.slice';
import { useAuth } from 'hooks/useAuth';
import { useAuthService } from 'store/services/auth.service';
import { onBoardingTutorialModal } from './Tour/styles/styles';

import { useCompanyService } from 'store/services/company.service';
import { UPDATE_COMPANY_ERROR, UPDATE_COMPANY_SUCCESS } from 'store/actions';

export default function OnBoardingTutorialModal() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const classes = onBoardingTutorialModal();
    const { user } = useAuth();

    const { updateEnableTutorials } = useAuthService();
    const { isLoading: finishLoading, getUserAssociatedCompany } = useCompanyService();
    const userData = useSelector((s) => s.company.data);

    const [open, setOpen] = useState(false);
    useEffect(() => {
        if (!userData?.email || !user?.data) return;

        const hasShownModal = localStorage.getItem('showOnboardingModal');

        if (!hasShownModal && user?.data?.wants_tutorial) {
            setOpen(true);
            localStorage.setItem('showOnboardingModal', 'shown');
        }
    }, [userData?.email, user?.data?.wants_tutorial]);

    const handleSkipTutorial = async () => {
        await updateEnableTutorials({ wants_tutorial: false });

        localStorage.setItem('showOnboardingModal', 'skipped');

        setOpen(false);
        dispatch(skipAllTours());
        dispatch(setTutorialPreference({ preference: 'skipped' }));
    };

    const handleStartTutorial = async () => {

        await getUserAssociatedCompany()
            .then((data) => {
                const companyData = data[0];
                dispatch(
                    UPDATE_COMPANY_SUCCESS({
                        data: {
                            id: companyData.id,
                            name: companyData.name,
                                    timezone: {
                                        label: companyData.timezone,
                                        value: companyData.timezone,
                                    },
                                    industry: {
                                        label: companyData.industry_name,
                                        value: companyData.industry,
                                    },
                                    entity: {
                                        label: companyData.entity,
                                        value: companyData.entity,
                                    },
                                    address: companyData.address,
                                    email: companyData.email,
                                    stripeTrialExpiry: companyData.subscription_trial_end,
                                    subscription_active: companyData.subscription_active,
                                    stripeStatus: companyData.stripe_status,
                                    is_invoice_reconciler: companyData.is_invoice_reconciler,
                                    is_purchase_reconciler: companyData.is_purchase_reconciler,
                                  
                                },
                            }),
                        );
                })
                .catch((err) => {
                    dispatch(UPDATE_COMPANY_ERROR({ err }));
                });
        
        dispatch(resetAllTours());
        localStorage.removeItem('tourState');
        await updateEnableTutorials({ wants_tutorial: true });
        // localStorage.setItem('showOnboardingModal', 'enabled');
        setOpen(false);
        dispatch(setTutorialPreference({ preference: 'enabled' }));
        // dispatch(startTour({ tourId: TOUR_TYPES.BANK_DROPDOWN }));
        navigate('/transactions/import-bank-transactions');
    };

    if (!userData) return null;

    return (
        <Modal
            open={open}
            handleClose={handleSkipTutorial}
            title="Welcome to Circler!"
            showFooter={false}
            maxWidth="sm"
            fullWidth
        >
            <Box sx={classes.container}>
                <Typography text={'Would you like to take a quick tour?'} sx={classes.title} />
                <RocketLaunchIcon sx={classes.icon} />
                <Typography
                    text={
                        'Our interactive tutorial will help you get familiar with the platform and show you how to use its key features.'
                    }
                    sx={classes.description}
                />

                {/* <Typography
                    text={
                        'You can always access tutorials later from the floating button at bottom right.'
                    }
                    color="textSecondary"
                    sx={{ marginBottom: '32px' }}
                /> */}

                <Typography
                    text={
                        '💡 Quick tip: You can restart the tutorials anytime by clicking the help icon in the bottom right corner of your screen. If you see a blue pulsing circle, click it to continue the tutorial from where you left off.'
                    }
                    sx={{ marginBottom: '25px' }}
                />

                <Box sx={classes.buttonsBox}>
                    <Button sx={classes.secondaryButton} onClick={handleSkipTutorial}>
                        Skip Tutorial
                    </Button>
                    <Button sx={classes.primaryButton} onClick={handleStartTutorial}>
                        Start Tutorial
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}
